import React , { useState } from 'react'
import './Header.css';
import { ScrollToTop } from './Scroll/ScrollToTop';
import { NavLink } from 'react-router-dom';
import { useEffect } from 'react';
import { NavigationType, useLocation, useNavigationType } from "react-router-dom";

const useBackButton = () => {
  const navType = useNavigationType();
  return navType === NavigationType.Pop;
};

const useScrollToTop = () => {
  const { pathname } = useLocation();

  const isPop = useBackButton();

  const scrollToTop = () => window.scrollTo(0, 0);

  useEffect(() => {
    scrollToTop();
  }, [pathname, isPop]);

  useEffect(() => {
    window.addEventListener("beforeunload", scrollToTop);
    return () => {
      window.removeEventListener("beforeunload", scrollToTop);
    };
  }, []);
};

const PrivacyPolicy = () => {

  useScrollToTop();

  const [click , setClick] = useState(false); 
  const handleClick = () => setClick(!click);

return (
    <>
     <div className="bg-background bg-no-repeat bg-[length:80%-100%] sm:bg-left-top lg:bg-contain py-2">
          <div className='lg:px-32 px-32 md:px-14 sm:px-12 flex flex-col justify-between items-center'>
          {/* List */}
            <div className={click ? "flex xl:flex items-center lg:justify-between md:justify-between w-full relative menu" 
            : "flex xl:flex items-center lg:justify-between md:justify-between w-full relative menu open" }>
                <NavLink to="/">
                    <img src="/assets/icons/tg_logo.svg" alt="" 
                      className={click ? "sm:absolute sm:right-10 sm:top-11 md:right-12 md:top-12 logo"
                      :"sm:absolute sm:right-10 sm:top-11 md:right-12 md:top-12  sm:hidden md:hidden lg:block logo" } />
                </NavLink>
                <div 
                className='xl:hidden lg:hidden text-5xl flex  sm:absolute sm:left-10 sm:top-11 md:left-11 md:top-12 z-30 text-gray'
                  onClick={handleClick}   >
                    <i className={click ? "fa-solid fa-bars" : "fa-solid fa-xmark"}></i>
                </div>
                <ul className={click ? "flex xl:flex lg:flex justify-between w-3/4 text-lg md:text-sm listItems sm:hidden md:hidden lg:pl-16 lg:pr-8" 
                : "flex xl:flex justify-between w-3/4 text-lg md:text-lg listItems lg:pl-16 lg:pr-8" }>
                    <li><NavLink to="/"  className='link link-underline link-underline-black hover:cursor-pointer '>الصفحة الرئيسية</NavLink></li>
                    <li><a href="#about-us"  className='link link-underline link-underline-black hover:cursor-pointer'>من نحـن</a></li>
                    <li><a href="#services"  className='link link-underline link-underline-black hover:cursor-pointer'>ماذا نقـدم</a></li>
                   <li><a  href="#features"  className='link link-underline link-underline-black hover:cursor-pointer'>المسـارات</a></li>
                    <li><a href="#ourwok"  className='link link-underline link-underline-black hover:cursor-pointer'>أعمالنـا</a></li>
                    <li><a href="#ourteam"  className='link link-underline link-underline-black hover:cursor-pointer'>فريقنـا</a></li>
                </ul>
            </div>

      <div className='text-center flex justify-between items-center mx-auto'>

        <div className="m-auto relative justify-center xl:max-w-[700px] lg:max-w-[700px] md:w-full sm:w-full">
          <div className="mx-14 lg:mx-14 md:mx-14 sm:mx-0">
            <h1 id="" className="my-32 lg:my-20 md:my-16 sm:my-16 underline underline-offset-[20px] font-semibold xl:text-3xl lg:text-3xl md:text-2xl">سياسة الخصوصية</h1>
            <img src="assets/images/Privacy/التعريف بالأكاديمية.svg" className="object-fill mb-32 sm:mb-12 h-fit w-[1353px]"/>
            <img src="assets/images/Privacy/شروط الأكاديمية.svg" className="object-fill mb-32 sm:mb-12 h-fit w-[1353px]"/>
            <img src="assets/images/Privacy/1.شرط الاستخدام.svg" className="object-fill mb-32 sm:mb-12 h-fit w-[1353px]"/>
            <img src="assets/images/Privacy/2.المراسلات الالكترونية.svg" className="object-fill mb-32 sm:mb-12 h-fit w-[1353px]"/>
            <img src="assets/images/Privacy/3.حقوق الملكية.svg" className="object-fill mb-32 sm:mb-12 h-fit w-[1353px]"/>
            <img src="assets/images/Privacy/4.حسابك.svg" className="object-fill mb-32 sm:mb-12 h-fit w-[1353px]"/>
            <img src="assets/images/Privacy/5.المراجعات.svg" className="object-fill mb-32 sm:mb-12 h-fit w-[1353px]"/>
            <img src="assets/images/Privacy/6.يحق للأكاديمية.svg" className="object-fill mb-32 sm:mb-12 h-fit w-[1353px]"/>
            <img src="assets/images/Privacy/7.مسؤوليتنا.svg" className="object-fill mb-32 sm:mb-12 h-fit w-[1353px]"/>
            <img src="assets/images/Privacy/8.التغيرات في الخدمة.svg" className="object-fill mb-32 sm:mb-12 h-fit w-[1353px]"/>
          </div>
        </div> 
      </div>

    </div>
    </div>
    <div>
    <div className="bg-[#F8F8F8] px-32 py-5 lg:text-[18px] md:text-[15px] sm:text-[8px] lg:h-[4rem] md:h-[4rem] sm:h-[3.5rem] ">
      <div className="xl:max-w-[1440px] xl:mx-auto flex justify-between md:flex-none sm:flex-none">
        <div className="flex ">
          <div className="">تواصــل معنــا</div>
          <div className="flex">
            <a href="https://t.me/TG_Academyy" target="_blank" rel="noreferrer">
              <img src="assets/images/telegram.svg" className='cursor-pointer lg:h-[25px] md:h-[25px] sm:h-[15px] lg:mr-4 sm:mr-1'/>
            </a>
            <a href="https://www.linkedin.com/company/thegame-academy/" target="_blank" rel="noreferrer">
              <img src="assets/images/Group1061.svg" className='cursor-pointer lg:h-[25px] md:h-[25px] sm:h-[15px] lg:mr-4 sm:mr-1'/>
            </a>
            <a href="https://www.facebook.com/tg.academy0/" target="_blank" rel="noreferrer">
              <img src="assets/images/facebook.svg" className='cursor-pointer lg:h-[25px] md:h-[25px] sm:h-[15px] lg:mr-4 sm:mr-1'/>
            </a>
          </div>
        </div>
        <div dir="ltr" className="flex md:flex-none sm:flex-none">
          <div className=""><span>&copy;</span> 2022 TG Developers</div>

        </div>
      </div>
    </div>
    </div>
    <ScrollToTop />
    </>
  )
}
export default PrivacyPolicy;